{{#if label}}
  <label for="{{id}}">{{t label}}</label>
{{/if}}
{{#if (equal helptext.position 'top')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}
<input {{#if id}} id={{id}} {{else}} id="checkbox-{{cid}}" {{/if}}
       {{#if value}}value="{{value}}"{{/if}}type="checkbox"
       {{#if checked}}checked="checked"{{/if}}
       class="checkbox {{checkbox_class}}" {{#if attributes}}data-attributable{{/if}} />
{{#if description}}
  <label {{#if id}} for={{id}} {{else}} for="checkbox-{{cid}}" {{/if}} {{#if checked}}class="checked"{{/if}}>
    {{t description}}
  </label>
{{/if}}
{{#if (equal helptext.position 'bottom')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}
